import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledPhoneInput = styled.div`
  width: 100%;
  position: relative;
  .select-btn-phone-country {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 44px;
    width: 54px;
    padding-left: 16px;
    padding-right: 4px;
    color: ${COLOR.darkGray};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    cursor: pointer;
    border-right: 1px solid ${COLOR.indigo[16]};
  }
  .select-custom {
    background-color: #fff;
    position: absolute;
    width: 220px;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
    top: 68px;
    overflow-y: auto;
    border-radius: 12px;
    z-index: 99;
  }
  .select-custom::-webkit-scrollbar {
    width: 8px;
  }

  .select-custom::-webkit-scrollbar-track {
    border-radius: 12px;
  }

  .select-custom::-webkit-scrollbar-thumb {
    border-radius: 12px;
  }
`;
